import { render } from "./DuplicationModal.vue?vue&type=template&id=5b7c9559&ts=true&lang=pug"
import script from "./DuplicationModal.vue?vue&type=script&lang=ts"
export * from "./DuplicationModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__